module.exports = __webpack_public_path__ + "img/certificate-3.c1228087.png";